import React, { useEffect, useState } from 'react';
import { Info } from 'lucide-react';
import styles from './MileageAnalysisTab_bus.module.css';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import useHttp from '../../../../hook/use-http';
import { useVehicleData } from './context';

const FuelEfficiencyCard = ({ selectedVehicleData, globalFilter, customFilter, setBestDayDate, benchmarkType }) => {
  const { GlobalData, setGlobalData } = useVehicleData();

  const { firstVinNo, secondVinNo } = selectedVehicleData
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [overallBestVehicle, setOverallBestVehicle] = useState("")
  const [fleetVehicle, setFleetVehicle] = useState("")
  const [nationalBestVehicle, setNationalBestVehicle] = useState("")
  const [primaryVehicleDetails, setPrimaryVehicleDetails] = useState({})
  const [customVehicleDetails, setCustomVehicleDetails] = useState({})
  const [fleetVehicleDetails, setFleetVehicleDetails] = useState({})
  const [nationalVehicleDetails, setNationalVehicleDetails] = useState({})


  const [vehicleData, setVehicleData] = useState({
    energyEfficiency: { primaryVehicle: null, bestVehicle: null, secondaryVehicle: null, nationalVehicle: null, fleetVehicle: null, },
    energyEfficiencyScore: { primaryVehicle: null, bestVehicle: null, secondaryVehicle: null, nationalVehicle: null, fleetVehicle: null, },
  })


  useEffect(() => {
    setGlobalData(prev => ({ ...prev, bestVehicle: overallBestVehicle, nationalVehicleId: nationalBestVehicle, bestFleetVehicleId: fleetVehicle, energyEfficiency: vehicleData, primaryVehicleDetails, customVehicleDetails, fleetVehicleDetails, nationalVehicleDetails }))
  }, [vehicleData, overallBestVehicle, fleetVehicle, nationalBestVehicle, primaryVehicleDetails, customVehicleDetails, fleetVehicleDetails, nationalVehicleDetails])

  // primary
  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + `mileage_analysis_ace/mileage_analysis_energy_efficiency`,
        body: {
          filterdata: {
            ...globalFilter,
            "VIN_NUM": [firstVinNo.vehicleId],
          }
        }
      },
      (res) => {
        const data = res[0]
        setPrimaryVehicleDetails(data?.key)
        setVehicleData(prevState => ({
          ...prevState,
          energyEfficiency: { ...prevState.energyEfficiency, primaryVehicle: data?.Energy_Efficiency?.value?.toFixed(2) ?? null },
        }));


      }
    );

    fetchData(
      {
        url: API_URL_MAIN + `mileage_analysis_ace/mileage_analysis_energy_efficiency_score`,
        body: {
          filterdata: {
            ...globalFilter,
            "VIN_NUM": [firstVinNo.vehicleId],
          }
        }
      },
      (res) => {
        const data = res[0]
        setVehicleData(prevState => ({
          ...prevState,
          energyEfficiencyScore: { ...prevState.energyEfficiencyScore, primaryVehicle: data?.Energy_Efficiency_Score?.value?.toFixed(2) ?? null },
        }));

      }
    );
  }, [firstVinNo.vehicleId, globalFilter])

  // best
  useEffect(() => {

    fetchData(
      {
        url: API_URL_MAIN + `mileage_analysis_ace/mileage_analysis_best_driven_energy_efficiency`,
        body: {
          filterdata: {
            ...globalFilter,
            "VIN_NUM": [firstVinNo.vehicleId],
          }
        }
      },
      (res) => {

        const data = res[0]
        setVehicleData(prevState => ({
          ...prevState,
          energyEfficiency: { ...prevState.energyEfficiency, bestVehicle: data?.Energy_Efficiency?.value?.toFixed(2) ?? null },
        }));
        setBestDayDate(data?.key?.eventdate)
        setOverallBestVehicle(data?.key?.eventdate)

      }
    );
    fetchData(
      {
        url: API_URL_MAIN + `mileage_analysis_ace/mileage_analysis_best_energy_efficiency_score`,
        body: {
          filterdata: {
            ...globalFilter,
            bestDate: GlobalData?.bestVehicle,
            "VIN_NUM": [firstVinNo.vehicleId],
          }
        }
      },
      (res) => {
        const data = res[0]

        setVehicleData(prevState => ({
          ...prevState,
          energyEfficiencyScore: { ...prevState.energyEfficiencyScore, bestVehicle: data?.Energy_Efficiency_Score?.value?.toFixed(2) ?? null },
        }));
        setBestDayDate(data?.key?.eventdate)
      }
    )
  }, [firstVinNo.vehicleId, globalFilter, GlobalData?.bestVehicle])

  // secondary

  useEffect(() => {
    let energyEfficiencyAPiCustom = "mileage_analysis_energy_efficiency"
    let energyEfficiencyAPiFleet = "mileage_analysis_fleet_energy_efficiency"
    let energyEfficiencyAPiNational = "mileage_analysis_national_energy_efficiency"

    let energyEfficiencyScoreAPiCustom = "mileage_analysis_energy_efficiency_score"
    let energyEfficiencyScoreAPiFleet = "mileage_analysis_fleet_energy_efficiency_score"
    let energyEfficiencyScoreAPiNational = "mileage_analysis_national_energy_efficiency_score"

    setVehicleData(prev => ({
      energyEfficiency: { ...prev.energyEfficiency, secondaryVehicle: null },
      energyEfficiencyScore: { ...prev.energyEfficiencyScore, secondaryVehicle: null },
    }))

    // custom

    if (secondVinNo?.vehicleId) {
      fetchData(
        {
          url: API_URL_MAIN + `mileage_analysis_ace/${energyEfficiencyAPiCustom}`,
          body: {
            filterdata: {
              ...customFilter,
              "VIN_NUM": [secondVinNo?.vehicleId],
            }
          }
        },
        (res) => {
          const data = res[0]
          setCustomVehicleDetails(data?.key)
          setVehicleData(prevState => ({
            ...prevState,
            energyEfficiency: { ...prevState.energyEfficiency, secondaryVehicle: data?.Energy_Efficiency?.value?.toFixed(2) ?? null },
          }));

        }
      )

      fetchData(
        {
          url: API_URL_MAIN + `mileage_analysis_ace/${energyEfficiencyScoreAPiCustom}`,
          body: {
            filterdata: {
              ...customFilter,
              "VIN_NUM": [secondVinNo?.vehicleId],
            }
          }
        },
        (res) => {
          const data = res[0]
          setVehicleData(prevState => ({
            ...prevState,
            energyEfficiencyScore: { ...prevState.energyEfficiencyScore, secondaryVehicle: data?.Energy_Efficiency_Score?.value?.toFixed(2) ?? null },
          }));

        }
      )
    }

    console.log("GlobalData?.bestFleetVehicleId", GlobalData?.bestFleetVehicleId)
    // Fleet
    let vinNoFleet = GlobalData?.bestFleetVehicleId ? [GlobalData?.bestFleetVehicleId] : []
    fetchData(
      {
        url: API_URL_MAIN + `mileage_analysis_ace/${energyEfficiencyAPiFleet}`,
        body: {
          filterdata: {
            ...globalFilter,
            "VIN_NUM": [],
          }
        }
      },
      (res) => {
        const data = res?.[0]
        setFleetVehicleDetails(data?.key)
        setVehicleData(prevState => ({
          ...prevState,
          energyEfficiency: { ...prevState.energyEfficiency, fleetVehicle: data?.Energy_Efficiency?.value?.toFixed(2) ?? null },
        }));

        if (!res.length) {
          setFleetVehicle("")
        }
        else {
          setFleetVehicle(data.key.vehicleId)
        }

      }
    )

    fetchData(
      {
        url: API_URL_MAIN + `mileage_analysis_ace/${energyEfficiencyScoreAPiFleet}`,
        body: {
          filterdata: {
            ...globalFilter,
            "VIN_NUM": vinNoFleet,
          }
        }
      },
      (res) => {
        const data = res[0]
        setVehicleData(prevState => ({
          ...prevState,
          energyEfficiencyScore: { ...prevState.energyEfficiencyScore, fleetVehicle: data?.Energy_Efficiency_Score?.value?.toFixed(2) ?? null },
        }));

      }
    )

    // National

    let vinNonNational = GlobalData?.nationalVehicleId ? [GlobalData?.nationalVehicleId] : []
    fetchData(
      {
        url: API_URL_MAIN + `mileage_analysis_ace/${energyEfficiencyAPiNational}`,
        body: {
          filterdata: {
            ...globalFilter,
            "VIN_NUM": [],
          }
        }
      },
      (res) => {
        const data = res[0]
        setNationalVehicleDetails(data?.key)
        setVehicleData(prevState => ({
          ...prevState,
          energyEfficiency: { ...prevState.energyEfficiency, nationalVehicle: data?.Energy_Efficiency?.value?.toFixed(2) ?? null },
        }));
        setNationalBestVehicle(data?.key?.vehicleId)
      }
    )

    fetchData(
      {
        url: API_URL_MAIN + `mileage_analysis_ace/${energyEfficiencyScoreAPiNational}`,
        body: {
          filterdata: {
            ...globalFilter,
            "VIN_NUM": vinNonNational,
          }
        }
      },
      (res) => {
        const data = res[0]
        setVehicleData(prevState => ({
          ...prevState,
          energyEfficiencyScore: { ...prevState.energyEfficiencyScore, nationalVehicle: data?.Energy_Efficiency_Score?.value?.toFixed(2) ?? null },
        }));

      }
    )

  }, [secondVinNo?.vehicleId, GlobalData?.bestFleetVehicleId, GlobalData?.nationalVehicleId, customFilter, globalFilter, benchmarkType])


  const cardData = [
    {
      key: "energyEfficiency",
      name: "Energy Efficiency",
      unit: "Wh/km"
    },
    {
      key: "energyEfficiencyScore",
      name: "Energy Efficiency Score",
      unit: ""
    }
  ]

  return (
    <div className="mb-0">
      {/* Fuel Efficiency Section */}

      {
        cardData.map((item, index) =>
          <div className="row mb-3" key={index}>
            <div className="col-12">
              <div className="row align-items-center">
                <div className="col-3">
                  <div className="d-flex align-items-center">
                    <h6 className={`mb-0 fw-bold me-2 ${styles.sectionTitle}`}>
                      {item.name} :
                    </h6>
                    {/* <Info size={14} className="text-muted" /> */}
                  </div>
                </div>
                <div className="col-3">
                  <div style={{ height: "40px" }} className={`p-3 d-flex justify-content-center align-items-center ${styles.dataCard}`}>
                    <span className={styles.dataValue}>
                      {vehicleData?.[item.key]?.primaryVehicle ? <>{vehicleData?.[item.key]?.primaryVehicle}{" " + item.unit}</> : <>--</>}
                    </span>
                  </div>
                </div>
                <div className="col-3">
                  <div style={{ height: "40px" }} className={`p-3 d-flex justify-content-center align-items-center ${styles.dataCard}`}>
                    <span className={styles.dataValue}>
                      {vehicleData?.[item.key]?.bestVehicle ? <>{vehicleData?.[item.key]?.bestVehicle}{" " + item.unit}</> : <>--</>}
                    </span>
                  </div>
                </div>
                <div className="col-3">
                  <div style={{ height: "40px" }} className={`p-3 d-flex justify-content-center align-items-center ${styles.dataCard}`}>
                    {
                      benchmarkType == "Custom" ?
                        <span className={styles.dataValue}>
                          {vehicleData?.[item.key]?.secondaryVehicle ? <>{vehicleData?.[item.key]?.secondaryVehicle}{" " + item.unit}</> : <>{secondVinNo?.vehicleId ? <>--</> : ""}</>}
                        </span> :
                        benchmarkType == "National" ?
                          <span className={styles.dataValue}>
                            {vehicleData?.[item.key]?.nationalVehicle ? <>{vehicleData?.[item.key]?.nationalVehicle}{" " + item.unit}</> : <>--</>}
                          </span> :
                          <span className={styles.dataValue}>
                            {vehicleData?.[item.key]?.fleetVehicle ? <>{vehicleData?.[item.key]?.fleetVehicle}{" " + item.unit}</> : <>--</>}
                          </span>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }
    </div>
  );
};

export default FuelEfficiencyCard;